import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider } from '@ibk/shared-translation';
import { BilletDiscontinuedBanner } from '../../components/BilletDiscontinuedBanner';
import { BillingWelcomeWizard } from '../../components/BillingWelcomeWizard';
import { ChargesList } from '../../components/ChargesList';
import { useChargesNavigation } from '../../hooks/useChargesNavigation';
import { useWelcomeWizard } from '../../hooks/useWelcomeWizard';
import { pagamentosTranslations } from '../../translations';
import styles from './ToReceive.module.css';
export function ToReceiveBase(props) {
    const { handleViewChargeDetails, handleViewChargePDF, handleCancelCharge, handleDownloadSlip } = useChargesNavigation();
    const wizard = useWelcomeWizard();
    return (_jsxs("main", { className: styles.main, "data-testid": props.dataTestId, children: [_jsx("div", { className: styles.actionCardsRow, children: _jsx(BilletDiscontinuedBanner, { onKnowBillingDomain: () => wizard.setIsOpen(true) }) }), _jsx("div", { className: styles.chargesTableSection, children: _jsx(ChargesList, { onViewDetails: handleViewChargeDetails, onViewPDF: handleViewChargePDF, onCancelCharge: handleCancelCharge, onDownloadSlip: handleDownloadSlip }) }), _jsx(BillingWelcomeWizard, { wizard: wizard })] }));
}
export function ToReceive(props) {
    return (_jsx(TranslationProvider, { translations: pagamentosTranslations, defaultLanguage: 'pt-BR', children: _jsx(ToReceiveBase, { ...props }) }));
}
